<div class="row mt-5 " *ngIf="company">
    <div class="accordion-item" style="background-color: rgb(85, 85, 85); ">
        <div class="accordion-header" id="flush-headingThree">
            <button class="accordion-button collapsed" type="button"
                data-bs-toggle="collapse" data-bs-target="#flush-collapseThree"
                aria-expanded="false" aria-controls="flush-collapseThree"
                style="background-color: rgb(85, 85, 85); color:whitesmoke; ">
                <h2>{{company?.name}} Hakkında</h2>
            </button>
        </div>
        <div id="flush-collapseThree" class="accordion-collapse collapse"
            aria-labelledby="flush-headingThree"
            data-bs-parent="#accordionFlushExample">
            <div class="accordion-body"
                style="background-color: rgb(85, 85, 85); color:whitesmoke">
                <picture *ngIf="company.imageUrl">
                    <source media="(max-width: 90px)" srcset="{{company.imageUrl}}" />
                    <source media="(min-width: 90px)" srcset="{{company.imageUrl}}" />
                    <img loading="lazy" width="90" height="60" src="{{company.imageUrl}}" alt="{{company.name}}" title="{{company.name}}">
                  </picture>
                  <ng-template ngFor let-info [ngForOf]="company?.infos" let-i="index" [ngForTrackBy]="trackByFnCompany">
                    <div [innerHTML]="company?.infos[i] | keepHtml" style="text-align: left;"></div>
                    <!-- <app-ads-header [adsId]="'1408095'"  [adsName]="'info-detail-1'+detail?.url" [adsStyle]="'#M856326ScriptRootC1408095{min-height: 300px;}'"></app-ads-header> -->
                </ng-template>
                <p *ngIf="company.siteUrl"><a href="{{company.siteUrl}}" target="_blank" title="{{company.name}}"><strong>{{company.name}}</strong> Şirket Sayfasına Ulaşmak İçin Tıklayınız!</a></p> 
            </div>
        </div>
    </div>
</div>